import { BuyerLandingPageData } from '@/types';

export type BuyerLandingPageDataReducer = Readonly<BuyerLandingPageData> | null;

// const initialState: BuyerLandingPageDataReducer = {
//     images: [],
//     messages: [],
//     milestones: [],
// };

const landingPageData = (state: BuyerLandingPageDataReducer = null, action): BuyerLandingPageDataReducer => {
    switch (action.type) {
        case 'SET_LANDING_PAGE':
            return action.data;
        default:
            return state;
    }
};

export default landingPageData;
